import { ref } from 'vue';

const bus = ref(new Map());

export function useEventBus() {
  function on(event, callback) {
    if (!bus.value.has(event)) {
      bus.value.set(event, []);
    }
    bus.value.get(event).push(callback);
  }

  function off(event, callback) {
    if (bus.value.has(event)) {
      bus.value.set(
        event,
        bus.value.get(event).filter((cb) => cb !== callback),
      );
    }
  }

  function emit(event, ...args) {
    if (bus.value.has(event)) {
      for (const callback of bus.value.get(event)) {
        callback(...args);
      }
    }
  }

  return { on, off, emit };
}
